type ExpeditionLike = {
  quotation?: { identifier: string } | null;
  customQuotation?: { identifier: string } | null;
};

export const getExpeditionIdentifier = (expedition: ExpeditionLike): string | undefined => {
  if (expedition.quotation) return `C-${expedition.quotation.identifier}`;
  if (expedition.customQuotation) return `D-${expedition.customQuotation.identifier}`;
  return undefined;
};
